import { RENTAL_PORTAL_LISTING_STATUSES } from '../../../../../../constants/rentalPortal'
import { EntityStatus } from '../../../../../Entity'
import { ICON_COLOR, ICON_HEIGHT_16, IconNG } from '../../../../../Icon'
import { ListingProfileWidgetPublishingCount } from '../ListingProfileWidgetPublishingCount'
import { ListingProfileWidgetPublishingManageButton } from '../ListingProfileWidgetPublishingManageButton'

import * as styles from './ListingProfileWidgetPublishingSummary.module.css'

import CheckmarkIcon from '../../../../../../icons/checkmark.svg'

function ListingProfileWidgetPublishingSummary({
  doneCount,
  isManageDisabled,
  listingStatus,
  manageTooltipKey,
  total,
  onClickManage,
}) {
  return (
    <div className={styles.ListingProfileWidgetPublishingSummary}>
      <EntityStatus
        id={listingStatus}
        statuses={RENTAL_PORTAL_LISTING_STATUSES}
      />
      <span className={styles.readinessChip}>
        <ListingProfileWidgetPublishingCount
          doneCount={doneCount}
          total={total}
        />
        <IconNG
          Icon={CheckmarkIcon}
          color={ICON_COLOR.CurrentColor}
          size={ICON_HEIGHT_16}
        />
      </span>
      <ListingProfileWidgetPublishingManageButton
        isDisabled={isManageDisabled}
        tooltipKey={manageTooltipKey}
        onClick={onClickManage}
      />
    </div>
  )
}

export default ListingProfileWidgetPublishingSummary
